import React from 'react'
import Jsonld from '@/modern/components/Seo/Jsonld'
import {
  SCHEMA_CONTEXT,
  WEBMOTORS_ORGANIZATION_ID,
} from '@/modern/components/Seo/schemas/constants'

const OnlineBusinessSchema = () => {
  const schemaTypeId = 'jsonld_onlinebusiness_da'

  const json = {
    '@context': SCHEMA_CONTEXT,
    '@type': 'OnlineBusiness',
    '@id': WEBMOTORS_ORGANIZATION_ID,
    name: 'Webmotors',
    url: 'https://www.webmotors.com.br',
    logo: 'https://www.webmotors.com.br/favicon.ico',
    description: 'A maior plataforma de compra e venda de veículos do Brasil.',
    sameAs: [
      'https://www.facebook.com/webmotors',
      'https://www.instagram.com/webmotors',
      'https://www.youtube.com/user/webmotors',
      'https://x.com/webmotors',
    ],
  }

  return <Jsonld id={schemaTypeId} dataQa={schemaTypeId} dataSchema={json} />
}

export default OnlineBusinessSchema
